// Modal confirmation dialog for clearing all chat sessions.

import React, { useEffect, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';

interface ClearAllDialogProps {
  onConfirm: () => void;
  onClose: () => void;
  label?: string;
}

export default function ClearAllDialog({ onConfirm, onClose, label = 'chats' }: ClearAllDialogProps) {
  const overlayRef = useRef<HTMLDivElement>(null);

  // Close on Escape
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  // Close on overlay click
  const handleOverlayClick = useCallback((e: React.MouseEvent) => {
    if (e.target === overlayRef.current) onClose();
  }, [onClose]);

  return ReactDOM.createPortal(
    <div
      ref={overlayRef}
      className="malpedia-clear-all-overlay"
      onClick={handleOverlayClick}
    >
      <div className="malpedia-clear-all-modal">
        <p className="malpedia-clear-all-modal-text">
          Are you sure you want to clear all {label}? This action cannot be undone.
        </p>
        <div className="malpedia-clear-all-modal-actions">
          <button
            className="malpedia-clear-all-modal-btn malpedia-clear-all-modal-btn--danger"
            onClick={onConfirm}
          >
            Clear All
          </button>
          <button
            className="malpedia-clear-all-modal-btn"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
